import React, { Suspense, lazy } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ROUTER_LIST from './routers';
import Loading from 'components/Loading';

// 懒加载组件的包装
const LazyComponent = importPath => {
  const Component = lazy(() => import(`pages/${importPath}`));
  return (
    <Suspense fallback={<Loading />}>
      <Component />
    </Suspense>
  );
};

const router = createBrowserRouter(
  ROUTER_LIST.map(route => {
    const AllErrorElement = lazy(() => import('components/Error'));
    return {
      path: route.path,
      element: LazyComponent(route.page),
      errorElement: route.errorElement ? LazyComponent(`${route.page}/${route.errorElement}`) : <AllErrorElement />
    };
  })
);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
